<template>
  <main>
    <h1>
      Hoxne Shop &amp; Post Office
    </h1>

    <section class="times">
      <p>
        Shop open from <b>9am until 5-30pm</b> Monday to Saturday,
        <br>
        <b>9am until 11am</b> Sunday.
      </p>
      <p>
        Post Office open from <b>9am until 5-30pm</b> weekdays (excl. Wednesday),
        <br>
        <b>9am until 1pm</b> on Wednesday,
        <br>
        <b>9am until 12.30pm</b> on Saturday.
      </p>
      <p>
        Closed on Bank Holidays.
      </p>
    </section>

    <section class="buttons">
      <a href="https://goo.gl/maps/iBMGXrBcWeF2" target="_blank" rel="noopener noreferrer">
        The Post Office, Low St, Hoxne, Suffolk IP21 5AR
      </a>
      <i>•</i>
      <a @click="email" href="mailto:hidden@hoxne.shop">
        <span class="email"></span>hoxne<span class="dot">·</span>shop
      </a>
      <i>•</i>
      <a href="tel:+441379668334">
        01379 668 334
      </a>
    </section>

    <section class="gallery">
      <img v-for="image in images" :key="image" :src="'/gallery/' + image + '.jpg'" alt="-">
    </section>

    <footer>
      Copyright © {{ year }} Hoxne Deli &amp; Tea Rooms Ltd
    </footer>

  </main>
</template>

<script>

  const images = [1,2,4,5,6,7,8,9,11,13,14,15,16,18,19]
  // const imagesShown = 12
  images.sort(() => Math.random() - 0.5)
  // images.splice(0, imageCount - imagesShown)

  export default {
    computed: {
      images() { return images },
      year() {
        return (new Date()).getFullYear()
      },
    },

    methods: {
      email(e) {
        e.preventDefault()

        const c = [
          'mail',
          'hel',
          '@ho',
          '.sh',
          'op',
          'xne',
          'lo',
          'to:',
        ]
        let email = ''
        for(let i = 0; i < (c.length / 2); i++)
          email += c[i] + c[c.length - 1 - i]
        window.location.href = email
        // console.log(email)
      },
    },
  }
</script>

<style lang="scss" scoped>
  $base: #630;
  $red: #c12;

  @mixin divider {
    &::after {
      display: block;
      content: ' ';
      width: 5rem;
      margin: 0 auto;
      padding-top: 1.5rem;
      border-bottom: 1px solid $base;
    }
  }

  main {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    min-height: 100vh;
    padding: 2.5rem;

    color: $base;
    text-align: center;
  }

  h1 {
    font-size: 1.3rem;
    // text-shadow: 0 0 2px #000, 0 0 2px #000;
    letter-spacing: 0.05em;
    color: $red;

    // @include divider;

    @include desktop {
      font-size: 1.79rem;
    }

    small {
      font-size: 1rem;
      color: #eee;
    }

    i {
      display: inline-block;
      padding: 0 0.25rem;
      color: $base;
    }
  }

  .buttons {
    width: 100%;
    padding-top: 1rem;

    // @include divider;

    i {
      display: none;
      padding: 0 0.5rem;
      color: $red;

      @include desktop {
        display: inline-block;
      }
    }

    a {
      padding: 0.5rem;
      margin-bottom: 0.5rem;
      // background-color: transparentize(#630, 0.9);

      @include tablet {
        max-width: 500px;
        margin: 0 auto 0.5rem auto;
      }

      @include desktop {
        display: inline-block;
        max-width: none;
        margin-bottom: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        background-color: transparentize(#630, 0.85);
      }

      svg {
        width: 1em;
        margin-right: 0.25em;
      }

      .email {
        display: inline-block;

        &::before {
          display: inline-block;
          // padding-left: 0.2em;
          content: 'hello@';
        }
      }

      .dot {
        display: inline-block;
        transform: translateY(0.2em);
      }
    }
  }

  .gallery {
    font-size: 0;
    padding-top: 1.5rem;
    width: 100%;

    // @include divider;

    @include tablet {
      max-width: 800px;
    }

    img {
      display: inline-block;
      width: 50%;
      height: auto;

      @include tablet {
        width: 100% / 3;
      }
      @include desktop {
        width: 20%;
      }
    }
  }

  .times {
    padding-top: 1.5rem;

    // @include divider;

    p {
      line-height: 1.4;
      padding-bottom: 1rem;

      &:last-child {
        padding-bottom: 0;
      }
    }

    b {
      display: inline-block;
      font-weight: bold;
    }

    br {
      display: none;

      @include desktop {
        display: block;
      }
    }

    aside {
      font-size: 0.8rem;
      padding-top: 0.15rem;
      opacity: 0.75;
    }
  }

  .times, .buttons {
    @include desktop {
      font-size: 1.35rem;
    }
  }

  footer {
    font-size: 0.75rem;
    text-align: center;
    padding-top: 1.5rem;
    // opacity: 0.5;
    // text-shadow: 0 0 0.25rem #000;
    color: $base;
  }
</style>
